import Http from '@/services/httpTypescript/index'
import Endpoints from '@/services/httpTypescript/endpoints'
import { ApiEndpoints } from '@/types'
import { type EditionStageResponse } from '@/schemas/edititionStage'

export default {
  fetchEditionStage() {
    return Http.get<EditionStageResponse>(Endpoints.get(ApiEndpoints.editionStage))
  }
}
